import {
  LIST_MEMBERSHIP_USER_REQUEST,
  LIST_MEMBERSHIP_USER_SUCCESS,
  LIST_MEMBERSHIP_USER_FAIL,
  VIEW_CARD_MEMBERSHIP_REQUEST,
  VIEW_CARD_MEMBERSHIP_SUCCESS,
  VIEW_CARD_MEMBERSHIP_FAIL,
  DETAIL_MEMBERSHIP_REQUEST,
  DETAIL_MEMBERSHIP_SUCCESS,
  DETAIL_MEMBERSHIP_FAIL,
  RESET_DETAIL_MEMBERSHIP_REQUEST,
  CREATE_MEMBERSHIP_REQUEST,
  CREATE_MEMBERSHIP_SUCCESS,
  CREATE_MEMBERSHIP_FAIL
} from '../../constants/users'

const initialState = {
  loading: false,
  loadingDetail: false,
  loadingUpdate: false,
  loadingViewCard: false,
  usersMembership: [],
  userMembership: {},
  detailMembership: {},
  error: null,
  status: '',
  message: '',
  pageable: {}
}

const usersMembershipReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MEMBERSHIP_USER_REQUEST:
      return { ...state, loading: true }
    case LIST_MEMBERSHIP_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        usersMembership: action.payload,
        pageable: action.pageable
      }
    case LIST_MEMBERSHIP_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        usersMembership: []
      }
    case VIEW_CARD_MEMBERSHIP_REQUEST:
      return { ...state, loadingViewCard: true }
    case VIEW_CARD_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        loadingViewCard: false
      }
    case VIEW_CARD_MEMBERSHIP_FAIL:
      return {
        ...state,
        loadingViewCard: false
      }
    case DETAIL_MEMBERSHIP_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        detailMembership: action.payload
      }
    case DETAIL_MEMBERSHIP_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }

    case RESET_DETAIL_MEMBERSHIP_REQUEST:
      return { ...state, loadingDetail: false, detailMembership: {} }

    case CREATE_MEMBERSHIP_REQUEST:
      return { ...state, loadingUpdate: true }
    case CREATE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        success: true
      }
    case CREATE_MEMBERSHIP_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    default:
      return state
  }
}

export default usersMembershipReducer
